/* Hipland motion: scroll reveal, slow parallax on photos, blur reveal. No libraries. Respects reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (reduce) return;
  root.classList.add('hl-js');

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function watch() {
    document.querySelectorAll('[data-reveal],[data-treat="blur"]').forEach(function (el) {
      if (!io) { el.classList.add('is-in'); return; }
      if (!el.__hl) { el.__hl = 1; io.observe(el); }
    });
  }

  var movers = [];
  function collect() { movers = [].slice.call(document.querySelectorAll('[data-motion]')); }
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || 800;
    movers.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2); // -1 .. 1
      el.style.setProperty('--p', Math.max(-1, Math.min(1, p)).toFixed(3));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function init() { watch(); collect(); frame(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', init);
})();
